import React from "react";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import {
  faAwardSimple,
  faFireFlame,
  faGem,
  faTrophy,
} from "@fortawesome/pro-duotone-svg-icons";
import { COLOR_GRAY_BORDER } from "../../common/colors";

export const STREAK_COLOR = "#EB7140";
export const STREAK_LIGHT_COLOR = "#FADDD1";

export type StatIconStyle = {
  icon: IconDefinition;
  secondaryColor: string;
  primaryColor: string;
  emptyPrimaryColor: string;
};

export const STAT_ICONS: Record<
  "streak" | "courses" | "lessons" | "gems",
  StatIconStyle
> = {
  streak: {
    icon: faFireFlame,
    secondaryColor: STREAK_COLOR,
    primaryColor: STREAK_LIGHT_COLOR,
    emptyPrimaryColor: "transparent",
  },
  courses: {
    icon: faTrophy,
    secondaryColor: "#C89A26",
    primaryColor: "#F9C427",
    emptyPrimaryColor: COLOR_GRAY_BORDER,
  },
  lessons: {
    icon: faAwardSimple,
    secondaryColor: "#1541AA",
    primaryColor: "#1555EA",
    emptyPrimaryColor: COLOR_GRAY_BORDER,
  },
  gems: {
    icon: faGem,
    secondaryColor: "#C067DB",
    primaryColor: "#8220A0",
    emptyPrimaryColor: "transparent",
  },
};

export const statIconColors = (style: StatIconStyle, isEmpty = false) => ({
  secondary: isEmpty ? COLOR_GRAY_BORDER : style.secondaryColor,
  primary: isEmpty ? style.emptyPrimaryColor : style.primaryColor,
});

export const DuotoneIcon: React.FC<
  { primary: string; secondary: string } & FontAwesomeIconProps
> = ({ primary, secondary, style, ...props }) => (
  <FontAwesomeIcon
    style={
      {
        "--fa-secondary-color": secondary,
        "--fa-secondary-opacity": 1,
        "--fa-primary-color": primary,
        ...style,
      } as React.CSSProperties
    }
    {...props}
  />
);

export const StatIcon: React.FC<
  { icon: StatIconStyle; isEmpty?: boolean } & Omit<
    FontAwesomeIconProps,
    "icon"
  >
> = ({ icon, isEmpty = false, ...props }) => (
  <DuotoneIcon icon={icon.icon} {...statIconColors(icon, isEmpty)} {...props} />
);
